module.exports = __webpack_public_path__ + "assets/img/041906.e3f5cd53.png";